import React, { useState } from "react";
import { SavingIndicator } from "@ucl/library";
import { useAtomValue } from "jotai";
import ContactModal from "./ContactPopover";
import "./PagesLayoutFooter.scss";
import { areAnySavesInFlightAtom } from "@/atoms/savingIndicatorAtom";
import contactIcon from "@assets/contact-icon.svg";

export interface PagesLayoutFooterProps {
  hideContactButton?: boolean;
}

export const PagesLayoutFooter: React.FC<PagesLayoutFooterProps> = (props) => {
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);

  return (
    <footer className="pages-layout-footer">
      <div className="pages-layout-footer__row">
        <div className="pages-layout-footer__verbiage">
          Powered by RelativityX
        </div>
        <div className="pages-layout-footer__center">
          <SavingIndicator
            isSaving={useAtomValue(areAnySavesInFlightAtom)}
            hideUntilSaved={false}
            savingTimeInMs={250}
          />
        </div>
        <div className="pages-layout-footer__right">
          {!props.hideContactButton && (
            <button
              className="pages-layout-footer__contact-btn"
              onClick={() => setIsContactModalOpen(true)}
            >
              <img src={contactIcon} alt="Contact Best Bank" />
              Contact Best Bank
            </button>
          )}
        </div>
      </div>
      <ContactModal isOpen={isContactModalOpen} onClose={() => setIsContactModalOpen(false)} />
    </footer>
  );
};

export default PagesLayoutFooter;
